import { store } from '../MainApp';
import axios from 'axios';

import * as auth from 'ducks/auth';
import appConfig from '../config';
// import { LOGIN_PAGE } from 'new-design/routes/common/constants';

// Status code.
// const NOT_ACCEPTABLE = 406;
const UNAUTHORIZED = 401;

// Tell Axios where to read the token from and which header to send
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

// If API is on a different origin AND you use cookies across origins:
axios.defaults.withCredentials = true;

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    const csrfTokenMatch = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);

    return {
      ...config,
      url: config.url.includes(appConfig.serverURL) ? config.url : `${appConfig.serverURL}${config.url}`,
      headers: {
        ...config.headers,
        'Content-Type': 'application/json',
        ...(csrfTokenMatch ? { [axios.defaults.xsrfHeaderName]: decodeURIComponent(csrfTokenMatch[1]) } : {}),
        ...(!store.getState().auth?.userInfo?.branchID
          ? { 'X-Branch-ID': store.getState().globalContext?.branchID || '' }
          : {}),
      },
      params: {
        ...config.params,
        // sessionID: store.getState().auth?.sessionID,
      },
    };
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return (
      response?.data || {
        errors: [],
        payload: [],
        warnings: [],
      }
    );
  },
  function (error) {
    // Handle expired token response error.
    if (
      error?.response?.status === UNAUTHORIZED &&
      store.getState().auth?.sessionID &&
      error?.config?.method === 'get'
    ) {
      store.dispatch(auth.actions.logoutSuccess());
      setTimeout(() => {
        store.dispatch(auth.actions.showExpiredModel());
      }, 10);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
